import React, { Component } from 'react'
import { Table,message } from 'antd'
import Filter from './Filter'
import API_URL from '../../common/url';
import SideNav from '../../components/contractManagement/SideNav'
import Fetch from '../../common/Fetch';
import $ from '../../common/AjaxRequest';
import TableC from "../basicElement/TableC";


export default class Activityitem extends Component {

    state = {
        searchParams:{},
        curParams:{},
        data:[],

        pagination:{
            current:1,
            pageSize:10
        },
    }

    componentDidMount() {
        this.loadData()
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });

        Fetch.post(API_URL.contract.queryActiveInvCodeList, {
            offset: current,
            limit: pageSize,
            ...searchParams
        
        }).then(res => {
            const { datas,totalCount } = res; 
            pagination.total = totalCount
            this.setState({
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    export = () => {
        const {searchParams} = this.state
        const options = {
            method: 'POST',
            url: API_URL.contract.exportActiveInvCodeList,
            data: {
                ...searchParams
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                
            },
        };
        $.sendRequest(options);
    }


    handleChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams }});
    }

    handleTableChange = (pagination) => {
        this.setState({pagination:pagination.pagination},() => {
            this.loadData();
        })
        
    }

    getColumns = () => {
        const columns = [        
            {
                title: 'JDE项目号',
                dataIndex: 'businessUnit',
                key: 'businessUnit',
                width: 120,
            }, {
                title: 'Project ID',
                dataIndex: 'projectId',
                key: 'projectId',
                width: 100,
            },{
                title: '公司代码',
                dataIndex: 'companyCode',
                key: 'companyCode',
                width: 100,
            },{
                title: '客户JDE号',
                dataIndex: 'customerJdeCode',
                key: 'customerJdeCode',
                width: 120,
            },{
                title: '客户名称',
                dataIndex: 'customerName',
                key: 'customerName',
                width: 160,
            },{
                title: '过账编辑',
                dataIndex: 'postingEdit',
                key: 'postingEdit',
                width: 100,
            },{
                title: '类别码10',
                dataIndex: 'code10',
                key: 'code10',
                width: 100,
            },{
                title: '类别码10描述1',
                dataIndex: 'code10Desc',
                key: 'code10Desc',
                width: 100,
                
            },{
                title: '类别码10描述2',
                dataIndex: 'code10Desc2',
                key: 'code10Desc2',
                width: 100,
            },{
                title: '类别码13',
                dataIndex: 'code13',
                key: 'code13',
                width: 100,
            },{
                title: '类别码13描述',
                dataIndex: 'code13Desc',
                key: 'code13Desc',
                width: 100,
            },{
                title: '账期',
                dataIndex: 'paymentTerms',
                key: 'paymentTerms',
                width: 100,
            }
        ]
        return columns
    }
    render() {
        const {data,searchParams,pagination} = this.state;
    return (
        <div className="content">
                <SideNav selectKey="activityitem" />
                <div className="main">
                    <div className="main-content">
                        <Filter
                            search={this.search}
                            export={this.export}
                            onChange={this.handleChange}    
                            searchParams={searchParams}
                        />
                    
                        <TableC
                            scrollY={500}
                            columns={this.getColumns()}
                            data={data}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </div>
            </div>
    )
    }
}



// WEBPACK FOOTER //
// ./src/components/activityitem/index.js